import { VideoElementReadyState } from './../constants/index';
export const isVideoPlaying = (video) => video.currentTime > 0 &&
    !video.paused &&
    !video.ended &&
    video.readyState > VideoElementReadyState.HaveCurrentData;
